




















import {Component, Prop, Vue} from 'vue-property-decorator';
import {UpdatedCompany} from '@/store/models';
import user from '@/store/modules/user';
import search from '@/store/modules/search';

@Component
export default class StartCompanyItem extends Vue {
    @Prop() updatedCompany: UpdatedCompany | undefined;

    get update() {
      if (!this.updatedCompany) {
        return {
          icon: '',
          title: '',
          desc: '',
        };
      }

      const period = this.updatedCompany.LastAccountPeriod;

      switch (this.updatedCompany.Type) {
        case 'status':
          if (this.updatedCompany.Status === 'Konkursinfo') {
            return {
              icon: 'siren',
              title: 'KONKURS',
              desc: this.updatedCompany.Name,
            };
          } else {
            return {
              icon: 'tag',
              title: 'NY STATUS',
              desc: `${this.updatedCompany.Name} (${this.updatedCompany.Status})`,
            };
          }
        case 'period':
          return {
            icon: 'calendar-check',
            title: 'NYTT BOKSLUT',
            desc: `${this.updatedCompany.Name} (20${period.substr( 0, 2 )}-${period.substr( 2, 2 )})`,
          };
        case 'name':
          return {
            icon: 'profile',
            title: 'NYTT NAMN',
            desc: this.updatedCompany.Name,
          };
      }
    }

  async updateCompany(OrgNr: string) {
    await user.setActiveExternalUser(null);
    await user.addCompany(OrgNr);
    await search.setTerm('');
    await this.$router.push({ name: 'overview', params: { OrgNr } });
  }

}
